import { useScript, useScriptTriggerConsent, useScriptTriggerElement } from '#imports';
import type { NuxtUseScriptOptions } from '#nuxt-scripts/types';
import type { Prettify } from 'viem';

export type UseScriptMetaframeOptions = Prettify<
    MetaframeOptions &
    Partial<NuxtUseScriptOptions> & {
        trigger?: 'immediate' | 'click' | 'hover' | 'visible' | 'manual' | 'onNuxtReady';
        requireConsent?: boolean;
        consentRef?: Ref<boolean>;
        el?: Ref<HTMLElement | undefined>;
    }
>;

export function useScriptMetaframe(options: UseScriptMetaframeOptions) {
    const isMobile
    = /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768;

    const {
        trigger = 'onNuxtReady',
        requireConsent = false,
        consentRef,
        el,
        ...metaframeOptions
    } = options;

    let resolvedTrigger: NuxtUseScriptOptions['trigger'] = trigger;

    if (requireConsent) {
        resolvedTrigger = useScriptTriggerConsent({
            consent: consentRef
        });
    }

    else if (
        trigger
        && ['hover', 'click', 'visible'].includes(trigger)
        && el
    ) {
        resolvedTrigger = useScriptTriggerElement({
            trigger,
            el
        });
    }

    const script = useScript<{ metaframe?: Metaframe }>(
        'https://cdn.xsolla.net/metaframe-web-wallet-widget-prod/container/v1/metaframe.js',
        {
            bundle: true,
            trigger: resolvedTrigger,
            use: () => ({
                metaframe: typeof window !== 'undefined' ? window.metaframe : undefined
            })
        }
    );

    script.onLoaded(({ metaframe }) => {
        if (!metaframe) {
            console.warn('[metaframe] not available');
            return;
        }

        metaframe.create({
            ...metaframeOptions,
            isMobile: metaframeOptions.isMobile ?? isMobile
        });
    });

    return script;
}
